// [Prov] Telefone exibido entre parênteses ao lado do nome do cliente (lista
// de conversas e cabeçalho da conversa).
const onlyDigits = value => (value || '').replace(/\D/g, '');

export const getContactPhoneLabel = contact => {
  const { name, phone_number: phoneNumber } = contact;
  // Contato sem pushName nasce com o próprio telefone como nome: não repetir.
  if (!phoneNumber || onlyDigits(phoneNumber) === onlyDigits(name)) return '';
  return `(${phoneNumber})`;
};
